<div id="about-text-container">
    <div id="about-text-english" class="about-text-language-section">
        <h1>
          <img class="about-logo" [src]="logoPath('en')" alt="VISP – Språkbanken’s speech research platform" />
        </h1>
        <h2 class="indented-headline">- a secure research platform for reproducible speech science</h2>
      
        <p>
          The Visible Speech (VISP) infrastructure provides access to a centralized environment for spoken language research that strives to meet both researchers' need for efficient workflows and the legislator's requirement of secured data management. The infrastructure offers the research community a unified environment for conducting reproducible speech signal processing in an environment that supports national and international collaborations. Digital archiving of hosted projects is also made easier by a uniform, documented, and transparent directory structure for all projects in VISP, which also reduces barriers to making data available in accordance with the FAIR principles.
        </p>
      
        <p>
          To meet the requirements of the legislator, we host projects that have received approval from the Swedish Ethical Review Authority for the processing and offer them a secure, isolated environment, with safety solutions that meet the Swedish Civil Contingencies Agency's requirements. The infrastructure has undergone security review to allow us to store and process speech regardless of speaker and content and has been designed from the ground up for that purpose.
        </p>
      
        <p>
          The platform is open for use by researchers at all SwamID-affiliated institutions after a review of ethical approval and GDPR alignment of the project.
        </p>
      
        <h3>Open access to speech based science</h3>
        <p>
          The VISP infrastructure offers additional digital tools either as open tools for every visitor to use in their work, in education or research, or specifically to Umeå University's and other higher education students, teachers, and researchers. Currently, the infrastructure hosts TRATT, a tool that facilitates the transcription of audio recordings' speech content. TRATT runs locally in the user's web browser, so audio files are never sent to the infrastructure or any other server. Therefore, researchers, students, and journalists can use the tool to transcribe and work with interview materials without special software licenses.
        </p>
      
        <h2>People</h2>
        <h3>Active contributors</h3>
        <ul>
          <li>Johan von Boer</li>
          <li>Fredrik Nylén</li>
          <li>Tomas Skotare</li>
        </ul>

        <h3>Honorable mentions</h3>
        <ul>
          <li>Kajsa Palm</li>
          <li>Linda Sandström</li>
          <li>Linnéa Tjernström</li>
        </ul>
      
        <p><strong>For further information, please contact:</strong><br>
          Fredrik Nylén (<a href="mailto:fredrik.nylen@umu.se">fredrik.nylen&#64;umu.se</a>)
        </p>
      </div>
      
    
      <div id="about-text-swedish" class="about-text-language-section">
        <h1>
          <img class="about-logo" [src]="logoPath('sv')" alt="VISP – Språkbankens talforskningsplattform" />
        </h1>
        <h2 class="indented-headline">- en säker forskningsinfrastruktur för forskning på talat språk</h2>
      
        <p>
          Infrastrukturen Visualiserat Språk (VISP) ger tillgång till en centraliserad miljö för forskning på talat språk och strävar efter att uppfylla både forskarens krav på effektiva analysverktyg och lagstiftningens krav på säker datahantering. För att möta de vetenskapliga kraven så erbjuder VISP forskaren ett enhetligt gränssnitt för bearbetning och analys av ljudinspelningar i en miljö som stödjer reproducerbarhet i databearbetning och samarbete mellan lokala och nationella grupper.
        </p>
      
        <p>
          För vetenskapligt utbyte underlättar vi slutlig digital arkivering av varje projekt genom att förse dem med en enhetlig, dokumenterad och transparent grundstruktur. Grunden har därmed också lagts för tillgängliggörande av projektets data i enlighet med FAIR-principerna. För att möta lagstiftarens krav sker användarens dagliga arbete i en säker isolerad miljö, efter tillbörlig etikprövning. Miljön har spårbarhet i förändringar inom projektet och säkerhetslösningar enligt Myndigheten för Samhällsskydd och Beredskaps föreskrifter. Infrastrukturen har genomgått säkerhets-genomlysning för att tillåta behandling av tal oavsett talare och innehåll och har designats för detta ändamål från start.
        </p>
      
        <p>
          Forskningsplattformen är öppen för alla forskare anslutna till en SwamID-anknuten organisation, efter granskning av etiskt tillstånd och att lagring och bearbetning av data på plattformen är tillåten enligt lagstiftning, inklusive GDPR.
        </p>
      
        <h3>Öppen tillgång till talbaserad vetenskap</h3>
        <p>
          Infrastrukturen har också en mer öppen del där digitala verktyg för forskning och undervisning görs tillgängliga för allmänheten, eller specifikt för Umeå Universitets och andra lärosätens studenter, lärare och forskare. Helt fritt tillgängliggör infrastrukturen just nu TRATT som är ett verktyg som underlättar transkribering av ljudinspelningars talinnehåll. TRATT körs lokalt i användarens web-läsare på ett sådant sätt att ljudfilerna inte i något led skickas till infrastrukturen eller någon annan server. Verktyget kan därför användas av forskare, studenter och journalister för att underlätta transkriptioner av intervjumaterial utan särskilda mjukvarulicenser.
        </p>
      
        <h2>Personer</h2>
        <h3>Aktiva medverkande</h3>
        <ul>
          <li>Johan von Boer</li>
          <li>Fredrik Nylén</li>
          <li>Tomas Skotare</li>
        </ul>

        <h3>Hedersomnämnanden</h3>
        <ul>
          <li>Kajsa Palm</li>
          <li>Linda Sandström</li>
          <li>Linnéa Tjernström</li>
        </ul>
      
        <p><strong>För mer information om infrastrukturen, kontakta:</strong><br>
          Fredrik Nylén (<a href="mailto:fredrik.nylen@umu.se">fredrik.nylen&#64;umu.se</a>)
        </p>
      </div>
      
</div>
